import * as THREE from 'three';

export function createRespawnSystem({
  world,
  dayNight,
  t,
  onBedExplode,
  showStatusByKey,
  getWorldSpawnPosition,
  findSafeRespawnNear
} = {}) {
  let bedRespawnAnchor = null;

  function sanitizeRespawnAnchor(raw) {
    if (!raw || typeof raw !== 'object') return null;
    const x = Math.round(Number(raw.x));
    const y = Math.round(Number(raw.y));
    const z = Math.round(Number(raw.z));
    if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(z)) return null;
    return { x, y, z };
  }

  function setRespawnAnchor(raw) {
    bedRespawnAnchor = sanitizeRespawnAnchor(raw);
    return getRespawnAnchor();
  }

  function getRespawnAnchor() {
    if (!bedRespawnAnchor) return null;
    return {
      x: bedRespawnAnchor.x,
      y: bedRespawnAnchor.y,
      z: bedRespawnAnchor.z
    };
  }

  function resolveRespawnPosition() {
    if (!bedRespawnAnchor) return getWorldSpawnPosition();

    const { x, y, z } = bedRespawnAnchor;
    if (world.getBlockIdAt(x, y, z) === 15) {
      const safe = findSafeRespawnNear(x, y, z);
      if (safe) return safe;
    }

    bedRespawnAnchor = null;
    showStatusByKey('status.bed_missing', {}, '', 2.6);
    return getWorldSpawnPosition();
  }

  function tryUseBed(block) {
    if (!block || block.userData?.id !== 15) return false;

    const dimension = world.getDimensionAt(block.position.x, block.position.z);
    if (dimension !== 'overworld') {
      const blastPos = new THREE.Vector3(block.position.x, block.position.y + 0.2, block.position.z);
      onBedExplode(blastPos);
      showStatusByKey('status.bed_explode', { dimension: t(`dimension.${dimension}`) }, '', 3.0);
      return true;
    }

    bedRespawnAnchor = {
      x: Math.round(block.position.x),
      y: Math.round(block.position.y),
      z: Math.round(block.position.z)
    };

    if (dayNight.skipNightToMorning()) showStatusByKey('status.bed_sleep');
    else showStatusByKey('status.bed_set');

    return true;
  }

  return {
    getRespawnAnchor,
    setRespawnAnchor,
    resolveRespawnPosition,
    tryUseBed
  };
}
